import {
  CANCEL_ADHERENCE,
  CHANGE_SELECT_PROVIDER,
  CONFIRM_ADHERENCE,
  CREATE_DATACENTER_PRESTADOR,
  CREATE_PROVIDER,
  DELETE_PROVIDER,
  DISABLE_ART_PRESTADOR,
  GET_ALL_PROVIDERS,
  GET_DATACENTER_PRESTADORES,
  GET_LIST_PROVIDERS,
  GET_PROVIDER_STATISTICS,
  GET_USER_PROVIDERS,
  REQUEST_ADHESION_BY_PROVIDER,
  UPDATE_DATACENTER_PRESTADOR,
  UPDATE_PROVIDER
} from "../actions/providers";

const INITIAL_STATE = {
  listProviders: {
    isFetching: false,
    didInvalidate: false,
    list: [],
    namesProviders: {},
  },
  isFetching: false,
  didInvalidate: false,
  list: [],
  selectedProvider: null,
  disableArtPrestador: {
    isFetching: false,
    didInvalidate: false,
    data: {},
  },
  providerStatistics: {
    isFetching: false,
    didInvalidate: false,
    data: {
      results: [],
      errors: []
    },
  },
  allProvidersOptions: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  datacenterList: {
    isFetching: false,
    didInvalidate: false,
    isLoadingEdit: false,
    list: [],
    lastActionMessage: "",
  },
};

const providers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${GET_USER_PROVIDERS}_REJECTED`:
      return {
        ...state,
        isFetching: false,
        didInvalidate: true,
      };
    case `${GET_USER_PROVIDERS}_PENDING`:
      return {
        ...state,
        isFetching: true,
        didInvalidate: false,
      };
    case `${GET_USER_PROVIDERS}_FULFILLED`: {
      let { selectedProvider, data } = action.payload;
      let defaultProvider = null;

      if (selectedProvider)
        defaultProvider = data.filter(
          (provider) => provider.id === selectedProvider,
        );

      const incomingProvider = action.payload.data[0]
        ? action.payload.data[0].id
        : null;

      selectedProvider = defaultProvider
        ? defaultProvider[0]?.id
        : incomingProvider;

      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        list: action.payload.data,
        selectedProvider,
      };
    }

    case CHANGE_SELECT_PROVIDER:
      return {
        ...state,
        selectedProvider: action.payload.provider,
      };

    case `${GET_LIST_PROVIDERS}_REJECTED`:
      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_LIST_PROVIDERS}_PENDING`:
      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_LIST_PROVIDERS}_FULFILLED`: {
      const dataHelp = {};
      action.payload.data.providers.forEach((item) => {
        dataHelp[item.nombre] = item.nombre;
      });

      return {
        ...state,
        listProviders: {
          isFetching: false,
          didInvalidate: false,
          list: action.payload.data.providers,
          namesProviders: dataHelp,
        },
      };
    }
    case `${CREATE_PROVIDER}_PENDING`:
      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${CREATE_PROVIDER}_REJECTED`:
      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${CREATE_PROVIDER}_FULFILLED`: {
      const listProviders = [...state.listProviders.list];
      listProviders.push({
        ...action.payload.provider,
        id: action.payload.data.id,
        arts: action.payload.provider.arts ?? action.payload.data?.arts ?? [],
      });

      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: false,
          didInvalidate: false,
          list: listProviders,
        },
      };
    }
    case `${UPDATE_PROVIDER}_PENDING`:
      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${UPDATE_PROVIDER}_REJECTED`:
      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${UPDATE_PROVIDER}_FULFILLED`: {
      const listProviders = state.listProviders.list.map((p) => {
        if (p.id === action.payload.provider.id) {
          return action.payload.provider;
        } else {
          return p;
        }
      });

      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: false,
          didInvalidate: false,
          list: listProviders,
        },
      };
    }
    case `${DELETE_PROVIDER}_PENDING`:
      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${DELETE_PROVIDER}_REJECTED`:
      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${DELETE_PROVIDER}_FULFILLED`: {
      const listProviders = [...state.listProviders.list];

      var removeIndex = listProviders
        .map((p) => {
          return p.id;
        })
        .indexOf(action.payload.id);

      listProviders.splice(removeIndex, 1);

      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: false,
          didInvalidate: false,
          list: listProviders,
        },
      };
    }
    case `${REQUEST_ADHESION_BY_PROVIDER}_PENDING`:
      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${REQUEST_ADHESION_BY_PROVIDER}_REJECTED`:
      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${REQUEST_ADHESION_BY_PROVIDER}_FULFILLED`: {
      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: false,
          didInvalidate: false,
        },
      };
    }
    case `${CANCEL_ADHERENCE}_PENDING`:
      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${CANCEL_ADHERENCE}_REJECTED`:
      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${CANCEL_ADHERENCE}_FULFILLED`: {
      const listProviders = state.listProviders.list;

      const provider = listProviders.find(
        (p) => p.id === action.payload.providerId,
      );

      const wriList = [...provider.arts];

      const removeIndex = wriList
        .map((art) => art.id)
        .indexOf(action.payload.adhesion.id);

      wriList.splice(removeIndex, 1);
      provider.arts = wriList;

      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: false,
          didInvalidate: false,
          list: listProviders,
        },
      };
    }
    case `${CONFIRM_ADHERENCE}_PENDING`:
      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${CONFIRM_ADHERENCE}_REJECTED`:
      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${CONFIRM_ADHERENCE}_FULFILLED`: {
      const listProviders = state.listProviders.list;

      const provider = listProviders.find(
        (p) => p.id === action.payload.providerId,
      );

      const wriList = [...provider.arts];

      wriList.forEach((art) => {
        if (art.id === action.payload.adhesion.id) {
          art.adherida = 0;
        }
      });

      provider.arts = wriList;

      return {
        ...state,
        listProviders: {
          ...state.listProviders,
          isFetching: false,
          didInvalidate: false,
          list: listProviders,
        },
      };
    }
    case `${DISABLE_ART_PRESTADOR}_PENDING`:
      return {
        ...state,
        disableArtPrestador: {
          ...state.disableArtPrestador,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${DISABLE_ART_PRESTADOR}_REJECTED`:
      return {
        ...state,
        disableArtPrestador: {
          ...state.disableArtPrestador,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${DISABLE_ART_PRESTADOR}_FULFILLED`: {
      return {
        ...state,
        disableArtPrestador: {
          ...state.disableArtPrestador,
          isFetching: false,
          didInvalidate: false,
        },
      };
    }
    case `${GET_PROVIDER_STATISTICS}_PENDING`:
      return {
        ...state,
        providerStatistics: {
          ...state.providerStatistics,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_PROVIDER_STATISTICS}_REJECTED`:
      return {
        ...state,
        providerStatistics: {
          ...state.providerStatistics,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_PROVIDER_STATISTICS}_FULFILLED`: {
      return {
        ...state,
        providerStatistics: {
          ...state.providerStatistics,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${GET_ALL_PROVIDERS}_PENDING`:
      return {
        ...state,
        allProvidersOptions: {
          ...state.allProvidersOptions,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_ALL_PROVIDERS}_REJECTED`:
      return {
        ...state,
        allProvidersOptions: {
          ...state.allProvidersOptions,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_ALL_PROVIDERS}_FULFILLED`: {
      return {
        ...state,
        allProvidersOptions: {
          ...state.allProvidersOptions,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${GET_DATACENTER_PRESTADORES}_PENDING`:
      return {
        ...state,
        datacenterList: {
          ...state.datacenterList,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_DATACENTER_PRESTADORES}_REJECTED`:
      return {
        ...state,
        datacenterList: {
          ...state.datacenterList,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_DATACENTER_PRESTADORES}_FULFILLED`:
      return {
        ...state,
        datacenterList: {
          ...state.datacenterList,
          isFetching: false,
          didInvalidate: false,
          list: action.payload.data,
        },
      };
    case `${CREATE_DATACENTER_PRESTADOR}_PENDING`:
    case `${UPDATE_DATACENTER_PRESTADOR}_PENDING`:
      return {
        ...state,
        datacenterList: {
          ...state.datacenterList,
          isLoadingEdit: true,
        },
      };
    case `${CREATE_DATACENTER_PRESTADOR}_REJECTED`:
    case `${UPDATE_DATACENTER_PRESTADOR}_REJECTED`:
      return {
        ...state,
        datacenterList: {
          ...state.datacenterList,
          isLoadingEdit: false,
          didInvalidate: true,
        },
      };
    case `${CREATE_DATACENTER_PRESTADOR}_FULFILLED`:
    case `${UPDATE_DATACENTER_PRESTADOR}_FULFILLED`:
      return {
        ...state,
        datacenterList: {
          ...state.datacenterList,
          isLoadingEdit: false,
          didInvalidate: false,
          lastActionMessage: action.payload?.data?.message || action.payload?.data || "",
        },
      };
    case "CLEAR_ALL_PROVIDERS":
      return {
        ...state,
        allProvidersOptions: {
          ...state.allProvidersOptions,
          data: [],
          isFetching: false,
          didInvalidate: false,
        },
      };
    default:
      return state;
  }
};

export default providers;
